export const PAGES = {
  EVENTS: {
    title: "Events",
    baseRoute: "events"
  },
};